$(document).ready(function () {


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * teleport links
    // *
    // * @set outer parent element class: js-href-teleport-wrapper
    // * @set link (<a> tag) element class: js-href-teleport-link
    // * @set element to add the link to class: js-href-teleport
    // *
    // * This adds a link tag (<a>) to other elements within a wrapper
    // * links comes from a link. Example: add a link to h2, image etc. inside a teaser
    // *
    $(".js-href-teleport").each(function () {
        var $link = $(this).parents(".js-href-teleport-wrapper").find(".js-href-teleport-link"),
            href = $link.attr("href"),
            target = $link.attr("target") ? $link.attr("target") : '_self';

        if (href) {
            $(this).wrapInner('<a href="' + href + '" target="' + target + '"></a>');
        }
    });



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * parent clickable elements (excludes links inside)
    // *
    // * @set outer parent element class: js-click-item-parent
    // * @set link (<a> tag) element class: js-click-item-link
    // *
    // * This makes the whole element clickable and still
    // * makes other links inside clickable with their target
    // *
    $(".js-click-item-parent").delegate('a', 'click', function (e) {
        var target = $(this).attr("target"),
            url = $(this).attr("href");

        if (target == "_blank") {
            window.open(url);
        } else {
            window.location = url;
        }
        return false;
    }).click(function () {
        var target = $(this).find("a.js-click-item-link").attr("target"),
            url = $(this).find("a.js-click-item-link").attr("href");

        if (target == "_blank") {
            window.open(url);
        } else {
            window.location = url;
        }
        return false;
    });




    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * animateIn
    // *
    // *
    var offset = 80; // Distance from Browserbottom & -top where the animation should start

    function fadeInElements() {
        var viewPortStart = $(window).scrollTop(),
            viewPortEnd = viewPortStart + $(window).height();


        $(".animateIn:visible").each(function () {
            var elementTop = $(this).offset().top,
                elementBottom = $(this).offset().top + $(this).outerHeight();

            if ((elementTop + offset) <= viewPortEnd && (elementBottom - offset) >= viewPortStart) {
                var delay = $(this).data("animation-delay");
                $(this).css("transition-delay", delay + "s").addClass("animateIn--active");
            } else {
                $(this).removeClass("animateIn--active");
            }
        });
    }

    $(window).scroll(function () {
        fadeInElements();
    });

    fadeInElements();


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * add target blank to external links
    // *
    // *
    $('a:not([data-targetblank=ignore])').each(function () {
        if (location.hostname === this.hostname || !this.hostname.length) {
            // ... do nothing?
        } else {
            $(this).attr('target', '_blank');
        }
    });


    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * navButton
    // *
    // *
    function toggleNav() {
        $(".js-navbutton").toggleClass("active");
        $(".js-header").toggleClass("navOpen");
        $(".js-nav").toggleClass("active");
        $("body").toggleClass("freeze");
    }

    function closeNav() {
        $(".js-navbutton").removeClass("active");
        $(".js-header").removeClass("navOpen");
        $(".js-nav").removeClass("active");
        $("body").removeClass("freeze");
    }

    $(".js-navbutton").click(toggleNav);

    $(document).keydown(function (e) {
        if (e.key === "Escape") {
            closeNav();
        }
    });
    // Close nav when window resizes above 1000px
    $(window).on("resize", function () {
        if ($(window).width() > 1000) {
            closeNav();
        }
    });

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * portraitSlider
    // *
    // *
    var $portraitSliderContainer = $(".js-portrait-slider-container");

    if ($portraitSliderContainer.length) {
        $portraitSliderContainer.each(function () {
            var $currentContainer = $(this);
            var $pairedContent = $currentContainer.find(".js-portrait-content-slider");
            var $slider = $currentContainer.find(".js-portrait-slider-track");

            $slider.slick({
                fade: true,
                infinite: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: false,
                autoplaySpeed: 2500,
                speed: 200,
                waitForAnimate: true,
                arrows: true,
                dots: true,
                pauseOnHover: true,
                appendDots: $currentContainer.find(".js-slider-dots"),
                prevArrow: $currentContainer.find(".js-portrait-slider-prev"),
                nextArrow: $currentContainer.find(".js-portrait-slider-next"),
                asNavFor: $pairedContent.find(".js-portrait-content-slider-track"),
            });

            $pairedContent.find(".js-portrait-content-slider-track").slick({
                fade: true,
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: false,
                adaptiveHeight: true,
                autoplaySpeed: 2500,
                speed: 200,
                waitForAnimate: true,
                arrows: false,
                dots: false,
                pauseOnHover: false,
                asNavFor: $currentContainer.find(".js-portrait-slider-track"),
            });

            // Function to update dot scales based on distance from active dot
            function updateDotScales() {
                var $dots = $currentContainer.find('.slick-dots li');
                var activeDotIndex = $dots.index($dots.filter('.slick-active'));

                $dots.each(function (index) {
                    var distance = Math.abs(index - activeDotIndex);
                    // Scale progression: active=1, +1 away=0.8, +2 away=0.6, +3+ away=0.4
                    var scale = Math.max(0.4, 1 - distance * 0.2);
                    var opacity = Math.max(0.5, 1 - distance * 0.15);

                    $(this).find('button').css({
                        '--dot-scale': scale,
                        '--dot-opacity': opacity
                    });
                });
            }

            // Update BEFORE slide changes (instant feedback)
            $slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                // Temporarily set the active dot to the next slide for instant visual feedback
                $currentContainer.find('.slick-dots li').removeClass('slick-active');
                $currentContainer.find('.slick-dots li').eq(nextSlide).addClass('slick-active');
                updateDotScales();
            });

            // Initial call
            updateDotScales();
        });
    }

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * imageGridSlider
    // *
    // *
    var $imageGridSlider = $(".js-image-grid-slider");

    if ($imageGridSlider.length) {
        $imageGridSlider.each(function () {
            var $currentContainer = $(this);
            var $slider = $currentContainer.find(".js-image-grid-slider-track");
            var $dotsContainer = $currentContainer.find(".js-slider-dots");

            $slider.slick({
                slidesToShow: 3,
                slidesToScroll: 1,
                fade: false,
                infinite: false,
                autoplay: false,
                autoplaySpeed: 2500,
                speed: 200,
                waitForAnimate: true,
                pauseOnHover: true,
                arrows: true,
                dots: false,
                appendDots: $dotsContainer,
                prevArrow: $(this).find(".js-image-grid-slider-prev"),
                nextArrow: $(this).find(".js-image-grid-slider-next"),
                responsive: [
                    {
                        breakpoint: 1000,
                        settings: {
                            slidesToShow: 2,
                            arrows: false,
                            dots: true,
                        },
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            dots: true,
                            slidesToShow: 1,
                            arrows: false,
                        },
                    },
                ],
            });



            // Update BEFORE slide changes
            $slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                $currentContainer.find('.slick-dots li').removeClass('slick-active');
                $currentContainer.find('.slick-dots li').eq(nextSlide).addClass('slick-active');


            });

        });
    }
    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * portraitGridSlider
    // *
    // *
    var $portraitGridSlider = $(".js-portrait-grid-slider");

    if ($portraitGridSlider.length) {
        $portraitGridSlider.each(function () {
            var $currentContainer = $(this);
            var $slider = $currentContainer.find(".js-portrait-grid-slider-track");
            var $videos = $slider.find("video");
            const hasVideo = $videos.length > 0;

            // Initialize Slick carousel
            $slider.slick({
                slidesToShow: 3,
                slidesToScroll: 1,
                fade: false,
                infinite: true,
                autoplay: false,
                autoplaySpeed: 2500,
                speed: 200,
                waitForAnimate: true,
                pauseOnHover: true,
                arrows: true,
                dots: false,
                appendDots: $currentContainer.find(".js-slider-dots"),
                prevArrow: $currentContainer.find(".js-portrait-grid-slider-prev"),
                nextArrow: $currentContainer.find(".js-portrait-grid-slider-next"),
                responsive: [
                    {
                        breakpoint: 1000,
                        settings: {
                            slidesToShow: 2,
                        },
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                            autoplay: !hasVideo,
                            dots: true,
                        },
                    },
                ],
            });

            // State variables
            let isInitial = true;
            let previousSlideIndex = 0;
            let currentSlideIndex = 0;
            let isResizing = false;
            let resizeTimeout;

            /**
             * Update progress bar for a specific video and dot
             */
            function updateVideoProgress(video, $dot) {
                if (video.duration > 0) {
                    const progress = (video.currentTime / video.duration) * 100;
                    $dot.css("--progress", progress + "%");
                    $dot.attr("data-progress", Math.round(progress));
                }
            }

            /**
             * Reset progress for all dots
             */
            function resetAllProgress() {
                $currentContainer.find(".slick-dots button").each(function () {
                    $(this).css("--progress", "0%");
                    $(this).attr("data-progress", 0);
                });
            }

            /**
             * Get the dot for a specific slide index
             */
            function getDotByIndex(index) {
                return $currentContainer.find(".slick-dots li").eq(index).find("button");
            }

            /**
             * Setup video event listeners
             */
            function setupVideoListeners() {
                $videos.each(function (videoIndex) {
                    // Update progress on timeupdate (only for active video)
                    this.addEventListener("timeupdate", function () {
                        if ($(window).width() <= 768) {
                            const $activeVideo = $slider.find(".slick-active video");

                            // Only update if this is the active video
                            if (this === $activeVideo[0]) {
                                const $activeDot = getDotByIndex(currentSlideIndex);
                                updateVideoProgress(this, $activeDot);
                            }
                        }
                    });

                    // Move to next slide when video ends
                    this.addEventListener("ended", function () {
                        const $activeDot = getDotByIndex(videoIndex);
                        updateVideoProgress(this, $activeDot);
                        $activeDot.addClass("has-played");
                        $slider.slick("slickNext");
                    });

                    // Update state when playing
                    this.addEventListener("play", function () {
                        // Additional play-related logic if needed
                    });

                    // Pause handler
                    this.addEventListener("pause", function () {
                        // Additional pause-related logic if needed
                    });
                });
            }

            /**
             * Handle slide change event
             */
            function handleSlideChange() {
                if ($(window).width() <= 768) {
                    currentSlideIndex = $slider.slick("slickCurrentSlide");

                    // Skip initial page load
                    if (isInitial) {
                        isInitial = false;
                        return;
                    }

                    // Skip if currently resizing
                    if (isResizing) {
                        return;
                    }

                    // Handle backward navigation
                    if (currentSlideIndex < previousSlideIndex) {
                        // Remove has-played from dots at current index and beyond
                        $currentContainer.find(".slick-dots li").each(function (index) {
                            if (index >= currentSlideIndex) {
                                $(this).find("button").removeClass("has-played");
                            }
                        });
                    } else {
                        // Mark previous slide as played
                        getDotByIndex(previousSlideIndex).addClass("has-played");
                    }

                    previousSlideIndex = currentSlideIndex;

                    // Stop and reset all videos in THIS slider only
                    $videos.each(function () {
                        this.pause();
                        this.currentTime = 0;
                    });

                    // Reset all progress bars
                    resetAllProgress();

                    // Play the active video
                    const $activeVideo = $slider.find(".slick-active video");
                    if ($activeVideo.length) {
                        $activeVideo[0].play();
                    }

                }
            }

            /**
             * Handle slider focus - pause all OTHER sliders' videos
             */
            function setupSliderFocus() {
                $currentContainer.on("click", function () {
                    // Pause videos from all OTHER sliders
                    $(".js-portrait-grid-slider").each(function () {
                        if (this !== $currentContainer[0]) {
                            const $otherVideos = $(this).find("video");
                            $otherVideos.each(function () {
                                this.pause();
                                this.currentTime = 0;
                            });
                        }
                    });
                });
            }

            /**
             * Setup resize listener to prevent video playback during resize
             */
            function setupResizeListener() {
                $(window).on("resize", function () {
                    isResizing = true;
                    clearTimeout(resizeTimeout);

                    resizeTimeout = setTimeout(function () {
                        isResizing = false;
                    }, 1000); // Adjust timeout as needed (in milliseconds)
                });
            }

            // Initialize all event listeners
            setupVideoListeners();
            setupSliderFocus();
            setupResizeListener();

            // Trigger on slide change
            $slider.on("afterChange", handleSlideChange);

            // Initial setup
            handleSlideChange();
        });
    }



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * video hover play - mobile click play
    // *
    // *
    var $videos = $(".js-video-hover");

    function updateVideoStates(video) {
        if (!video.paused) {
            $(video).addClass("is-playing");
        } else {
            $(video).removeClass("is-playing");
        }
    }

    // Check if device supports coarse pointer (touch)
    var isCoarsePointer = window.matchMedia("(pointer: coarse)").matches;

    $videos.on("click", function () {
        if (this.paused) {
            this.play();
            updateVideoStates(this)
        } else {
            this.pause();
            updateVideoStates(this)
        }
    });
    if (!isCoarsePointer) {
        // Fine pointer (mouse): hover to play, unhover to pause
        $videos.on("mouseenter", function () {
            this.play();
            updateVideoStates(this)
        });

        $videos.on("mouseleave", function () {
            // this.load();  // Reload to show poster
            this.pause();
            // this.currentTime = 0;
            updateVideoStates(this)
        });
    }




    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * footer dropdown
    // *
    // *
    var $dropdownButton = $(".js-footer-dropdownbutton");
    var $dropdownContent = $(".js-footer-dropdowncontent");

    $dropdownButton.on("click", function (e) {
        var $currentButton = $(this);
        var $currentDropdown = $currentButton.siblings(".js-footer-dropdowncontent");
        var isOpen = $currentDropdown.hasClass("is-open");

        $currentDropdown.toggleClass("is-open");
        $currentDropdown.attr("aria-expanded", !isOpen);
    });

    // Close dropdown when clicking outside
    $(document).on("click", function (e) {
        if (!$(e.target).closest(".js-footer-dropdownbutton, .js-footer-dropdowncontent").length) {
            $dropdownContent.removeClass("is-open");
            $dropdownContent.attr("aria-expanded", "false");
        }
    });



    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * accordion
    // *
    // *
    $(".js-accordion-button").click(function () {
        // Toggle the aria-expanded attribute for the current accordion item
        const $content = $(this).siblings(".js-accordion-content");
        const isExpanded = $content.attr("aria-expanded") === "true";
        $content.attr("aria-expanded", !isExpanded);

        // Close other accordion items
        $(this).parents(".js-accordion-wrapper")
            .find(".js-accordion-content")
            .not($content)
            .attr("aria-expanded", "false");

        setTimeout(() => {
            $(this)[0].scrollIntoView({ behavior: 'smooth' });
        }, 400);
    });

    function openAccordionFromHash() {
        let hash = window.location.hash.split('#')[1];
        if (hash && $("#" + hash).hasClass("js-accordion-button") && $("#" + hash).siblings(".js-accordion-content").attr("aria-expanded") !== "true") {
            $("#" + hash).click();
        }
    }

    // open acoordion on load
    openAccordionFromHash();

    // open accordion from same page
    $(window).on('hashchange', function () {
        openAccordionFromHash();
    });

    // * * * * * * * * * * * * * * * * * * * * * * * * *
    // * header dropdown
    // *
    // *
    $('.js-header-dropdownbutton').on('click', function (e) {
        e.preventDefault();
        var $dropdown = $(this).siblings('.js-header-dropdowncontent');
        var isExpanded = $dropdown.attr('aria-expanded') === 'true';
        $dropdown.attr('aria-expanded', !isExpanded);
    });


});



// * * * * * * * * * * * * * * * * * * * * * * * * *
// * sticky Header
// *
// *
$(window).on("load scroll", function () {
    if ($(window).scrollTop() >= 40) {
        $(".js-header").addClass("sticky");
    } else {
        $(".js-header").removeClass("sticky");
    }
});
